module.exports = __webpack_public_path__ + "static/media/18.7a3219f5.png";